import { GetSubscriptionItem } from "../queries/GetSubscriptionItem.pim.js";
export const fetchSubscriptionItem = async (sku, { client }) => {
    const data = await client.pim.request(GetSubscriptionItem, {
        sku,
        language: "no-nb",
        tenantId: client.tenantId,
    });
    const subscription = data.product?.getVariants?.[0];
    if (!subscription) {
        throw new Error(`Could not find subscription item for sku ${sku}!`);
    }
    return subscription;
};
